import { Modal } from "components";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import UserToClientModalPicker from "components/Picker/UserToClientPicker/UserToClientModalPicker";
import React from "react";
import { ICalendarTemplatePicker } from "./ICalendarTemplatePicker";

interface Props {
  excludeUserIds: number[];
  artistId: number;
  isOpen: boolean;
  onClose: () => void;
  onCreated: () => void;
}

interface NewICalendarFeedFormState {
  owner: server.dto.UserToClientSmall;
  template: server.dto.ICalendarTemplateSmall;
}

export const NewICalendarFeedModal = (props: Props) => {
  const [formState, setFormState] = React.useState<NewICalendarFeedFormState>({
    owner: null,
    template: null,
  });

  const onChange = (newData: Partial<NewICalendarFeedFormState>) => {
    setFormState((prevState) => ({
      ...prevState,
      ...newData,
    }));
  }

  const submit = () => {
    return window.CoreApi.ICalendarFeed.CreateCalendarFeed({
      artistId: props.artistId,
      ownerUserToClientId: formState.owner.userToClientId,
      iCalendarTemplateId: formState.template?.iCalendarTemplateId,
    })
  }

  const onSuccess = async () => {
    props.onCreated();
  }

  return <Modal
    isOpen={props.isOpen}
    title={RESX.Feed.NewICalendarFeed}
    handleClose={props.onClose}
    width="tiny"
  >
    <div className="grow1 scrollbox-auto">
      <EditSectionTemplate
        submit={submit}
        noPanels
        onSuccess={onSuccess}
        sections={[
          {
            key: "icalendarfeedDetails",
            type: "regular",
            title: RESX.Feed.NewICalendarFeed,
            fields: [{
              key: "owner",
              label: RESX.GeneralLabels.AssignTo,
              renderEditNew: () => <div className="main-section-template-fields-padding">
                <UserToClientModalPicker
                  excludeUserIds={props.excludeUserIds}
                  canCreateNew={false}
                  canChooseExternal
                  nonInPageEditing={{
                    onChange: owner => onChange({ owner }),
                    value: formState.owner,
                    validatorKey: "owner",
                    required: true,
                  }}
                />
              </div>
            }, {
              key: "template",
              label: RESX.Template.ICalendarTemplate,
              renderEditNew: () => <ICalendarTemplatePicker
                value={formState.template}
                onChange={template => onChange({ template })}
              />
            }]
          }
        ]}
      />
    </div>
  </Modal>
}